
/**
 * @typedef {Object} tooltipOptions
 * @property {string?} position 表示位置
 * @property {string?} text 表示内容
 */

/**
	* ツールチップ部品
	*/
export default class Tooltip {
	/** @type {tooltipOptions} 表示オプション */
	#options = {
		position: "bottom",
		text: ""
	}

	/**
	 * @type {HTMLElement}
	 */
	#tooltipEl = null

	#removeListeners

	/**
	 * @type {HTMLElement|null}
	 */
	#currentTargetEl = null

	/**
	 *
	 * @param {tooltipOptions} options 表示オプション
	 */
	constructor (options) {
		this.#options = {
			...this.#options,
			...options
		}
	}

	/**
	 * tip設定処理
	 */
	init (el) {
		if (!this.#tooltipEl) {
			this.#tooltipEl = this.#createTooltip()
			document.body.appendChild(this.#tooltipEl)
		}
		this.#addListeners(el)
	}

	destroy () {
		if (this.#tooltipEl) this.#tooltipEl.remove()
		if (this.#removeListeners) this.#removeListeners()
	}

	hideIfCurrent (el) {
		if (el === this.#currentTargetEl && this.#tooltipEl) {
			this.#tooltipEl.hide()
		}
	}

	/**
	 * tip表示内容変更処理
	 * @param {strins} text
	 */
	updateText (text) {
		this.#options.text = text
	}

	/**
	 * ツールチップ生成処理
	 * @param {HTMLElement?} el
	 */
	#addListeners (el) {
		// 表示
		const showTooltip = _ => {
			this.#updateTooltip(el)
			// 前のテキストでサイズ計算してしまうので、1フレーム待つ
			if (["top", "bottom"].includes(this.#tooltipEl.position)) {
				this.#tooltipEl.showAtTarget({ target: el, offsetY: true, offsetX: false, additionalOffsetY: 4 })
			} else {
				this.#tooltipEl.showAtTarget({ target: el, offsetY: false, offsetX: true, additionalOffsetX: 4 })
			}
			this.#currentTargetEl = el
		}
		el.addEventListener("mouseover", showTooltip)

		// マウスが外れる時
		const hideTooltip = _ => {
			this.#tooltipEl.hide()
			this.#currentTargetEl = null
		}
		el.addEventListener("mouseleave", hideTooltip)

		this.#removeListeners = () => {
			el.removeEventListener("mouseover", showTooltip)
			el.removeEventListener("mouseleave", hideTooltip)
		}
	}

	#updateTooltip (el) {
		let position = this.#options.position
		if (el.dataset.position) {
			position = el.dataset.position
		}
		this.#tooltipEl.position = position

		const tooltip = this.#tooltipEl.querySelector(".tooltip")
		let text = this.#options.text
		if (el.dataset.tooltip) {
			text = el.dataset.tooltip
		}
		tooltip.textContent = text
	}

	#createTooltip () {
		const template = document.createElement("template")
		template.innerHTML = /* html */`
		<bui-popup>
			<div class="tooltip">
			</div>
		</bui-popup>
		`
		const messabeBoxEl = template.content
		const popup = messabeBoxEl.querySelector("bui-popup")
		return popup
	}
}
